import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/query-keys';
import { financialService } from '../../services/financial.service';

export function useAPInvoices(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.apInvoices.all(orgId ?? ''),
    queryFn: () => financialService.getAPInvoices(orgId ?? undefined),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => Array.isArray(res.data) ? res.data : [],
  });
}
